<div class="unlockStory">
  <div class="wid100 pad30 matchDetails">
    <h3>Add Match Details</h3>
    <div class="wid100">
      <div class="selectBoxCompany">
        <div class="form">
          <ul>
            <li class="wid100">
              <label class="toggleName">Series Name</label>
            <!--  <label>Name</label>-->
              <div class="dataField">
                <input type="text" class="textBox" placeholder="Search Series" [(ngModel)]="seriesInputQuery"
                [formControl]='searchQuery' (keyup)="filterAutoCompleteKeyUp($event ,'section')" (click) = "cssBlock = 'block'"
                  (keydown)="filterAutoCompleteKeyDown($event ,'section')" (focus)="focusInSuggestion('section')"
                  (focusout)="false">
                <div #sectionList [ngClass]="'autosuggestion ' + cssBlock" *ngIf="seriesList && seriesList.length > 0">
                  <ul *ngFor="let item of seriesList;let i = index">
                    <li (click)="setMatchData(item)">
                      <span class="name">{{item.seriesName}}</span>
                      <!-- <span class="emails">(nitesh.rawal@htdigital.in)</span> -->
                    </li>
                  </ul>
                </div>
                <ng-container *ngIf="(1 > seriesList.length) && cssBlock">
                  <div class="autosuggestion block">
                    <ul>
                      <li><span class="name">No Results</span></li>
                    </ul>
                  </div>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="wid100" *ngIf="matchId">
      <label class="toggleName">Match Name</label>
      <div class="selectBoxCompany">
        <select (change)="getMatchDetails($event)" [(ngModel)]="matchId">
          <option>Select Match</option>
          <option *ngFor="let item of matchList" [value]="item.matchId">{{item.matchName}}</option>
        </select>
      </div>
    </div>
    <div class="wid100" *ngIf="!matchId">
      <label class="toggleName">Match Name</label>
      <div class="selectBoxCompany">
        <select (change)="getMatchDetails($event)">
          <option>Select Match</option>
          <option *ngFor="let item of matchList" [value]="item.matchId">{{item.matchName}}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="fr wid100 right padlr30 ptb15">
    <button type="button" tabindex="0" name="cancel" (click)="closeMatchPopup()"
      class="cancel gray ml10">Cancel</button>
    <button type="button" tabindex="0" name="unlock"  (click)="saveMatchDetails()" class="add blue ml10 ">Done</button>
  </div>
</div>
